const SPRITE_URL = 'img/icons/sprite.svg';
export const ICON_SPRITE_ROOT_ID = 'icon-sprite';

let spritePromise = null;

export function isIconSpriteInDom() {
  return !!document.getElementById(ICON_SPRITE_ROOT_ID);
}

/** Inline img/icons/sprite.svg so <use href="#icon-..."> works in the document. */
export function ensureIconSprite() {
  if (spritePromise) {
    return spritePromise;
  }

  if (isIconSpriteInDom()) {
    spritePromise = Promise.resolve(true);
    return spritePromise;
  }

  spritePromise = fetch(SPRITE_URL)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to load icon sprite (${response.status})`);
      }
      return response.text();
    })
    .then(svg => {
      const root = document.createElement('div');
      root.id = ICON_SPRITE_ROOT_ID;
      root.setAttribute('aria-hidden', 'true');
      root.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
      root.innerHTML = svg;
      document.body.insertBefore(root, document.body.firstChild);
      return true;
    })
    .catch(() => {
      spritePromise = null;
      return false;
    });

  return spritePromise;
}
